import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String }
  static targets = ["list"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "opacity-30",
      dragClass: "shadow-xl",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async onEnd() {
    const sectionIds = Array.from(this.listTarget.children).map(el => el.dataset.sectionId)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ section_ids: sectionIds })
      })

      if (!response.ok) throw new Error("Reorder failed")
    } catch (error) {
      console.error("Failed to reorder sections:", error)
      window.location.reload()
    }
  }
}
